import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionService } from 'src/app/session.service';
import { ApiServiceService } from 'src/app/api-service.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-lock-screen',
    templateUrl: './lock-screen.component.html',
    styleUrls: ['./lock-screen.component.scss'],
    standalone: false
})
export class LockScreenComponent {
  form: FormGroup;
  invalid = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<LockScreenComponent>,
    private sessionService: SessionService,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService:ApiServiceService
  ) {
    this.form = this.fb.group({
      password: ['', Validators.required]
    });
  }

  async unlock() {
    if (await this.sessionService.validatePassword(this.data,this.form.value.password)) {
      sessionStorage.removeItem('locked');
      this.apiService.updateUnlockLastLogin(this.data).subscribe(res=>{
        console.log("");
      })
      this.dialogRef.close();
    } else {
      this.invalid = true;
    }
  }
}